(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
window.jade = require('jade/runtime')
window.Backbone = require('backbone')
window.Backbone.$ = $

var serviceLocator = window.serviceLocator = {}
  , debug = require('./lib/debug')('index')
  , createAcl = require('./lib/acl')
  , getRoles = require('./lib/roles')
  , security = require('./lib/security')
  , Emitter = require('events').EventEmitter

function loadConfig (cb) {
  Backbone.ajax(
    { url: '/config.json'
    , dataType: 'json'
    , type: 'GET'
    , success: cb
    })
}

// Load the ACL
function loadAcl (callback) {
  debug('Loading ACL...')
  Backbone.ajax(
    { url: window.config.apiUrl + '/acl'
    , dataType: 'json'
    , type: 'GET'
    , success: function (data) {
        debug('New ACL Loaded')
        serviceLocator.acl = createAcl(data)
        if (typeof callback === 'function') callback()
        serviceLocator.hub.emit('acl:load')
      }
    })
}

serviceLocator.loadAcl = loadAcl

// Returns true if the ACL allows them access
serviceLocator.allowed = function (resource, action) {

  var isAllowed = serviceLocator.acl.allowed(serviceLocator.session.roles, resource, action)
  debug('Checking for permission in ACL. Resource: '
    , resource, 'Action:', action, 'Allowed:', isAllowed, serviceLocator.session.roles)

  return isAllowed
}

// Display message and go back if now allowed
serviceLocator.allow = function (resource, action) {
  if (!serviceLocator.allowed(resource, action)) {
    window.alert('You don\'t have the rights to perform that action.')
    // serviceLocator.router.navigate('no-access', { trigger: true })
    window.history.back()
    return false
  }
  return true
}

serviceLocator.session = { roles: getRoles() }

loadConfig(function (config) {
  if (!config) throw new Error('Unable to load config')

  window.config = config
  window.debug = (window.config.logLevel === 'debug')

  serviceLocator.hub = new Emitter()

  // Get the 'global' libs

  require('./lib/vendor/animate')
  require('./lib/vendor/zepto-fx')
  require('./lib/vendor/select2')
  require('./lib/vendor/selectize')
  require('./lib/vendor/bootstrap/js/bootstrap')
  require('./lib/smooth-scrolling')
  require('./lib/fixed-sidebar')
  require('./lib/vendor/jquery-ui-1.10.1.custom')
  require('./lib/vendor/jquery.ui.touch-punch')
  require('./lib/vendor/jquery.stickem')
  require('./lib/vendor/picker')
  require('./lib/vendor/picker.date')
  require('./lib/vendor/picker.time')
  require('./lib/vendor/summernote')

  // Setting locale for moment.js to English (England) and setting
  // a custom calender format (uses 24 clock instead of default AM/PM)
  var moment = require('moment')
  moment.locale('en-gb'
    , { calendar:
        { lastDay: '[Yesterday at] HH:mm'
        , sameDay: '[Today at] HH:mm'
        , nextDay: '[Tomorrow at] HH:mm'
        , lastWeek: '[last] dddd [at] HH:mm'
        , nextWeek: 'dddd [at] HH:mm'
        , sameElse: 'L'
        }
      })

  // Add custom js components
  require('./lib/vendor/jquery-ui-timepicker-addon')
  require('./lib/dateTimeSelect.jquery')
  require('./lib/dateSelect.jquery')

  var setupLoadingBar = require('./lib/global-loading')

  setupLoadingBar('.toolbar', 300, debug)

  debug('Creating router')
  var Router = require('./router')

  serviceLocator.router = new Router()

  require('./not-found/routes')(serviceLocator)
  require('./index/routes')(serviceLocator)

  // Core bundles
  require('./administrator/routes')(serviceLocator)
  require('./role/routes')(serviceLocator)

  // Load the components
  require('./components')(serviceLocator)

  require('./api-error/')(serviceLocator)

  Backbone.history.on('route', function () {
    $('div.modal-overlay').remove()
  })

  if (security.isAuthed()) {
    loadAcl(function () {
      Backbone.history.start({ pushState: true, root: '/' })
    })
  } else {
    // If not authed then take to login
    security.logout()
  }
})

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/index.js","/admin/source/js/app")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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